import React, { useEffect, useState } from 'react'

interface MessageInfoProps {
  message: string | null
  duration: number // duration in milliseconds
  trigger: number // a unique trigger to reset the display
  type: number
  onTimeout: () => void
  noCenter?: boolean
}

interface InfoProps {
  message: string
  trigger: number // a unique trigger to reset the display
  onTimeout: () => void
  noCenter?: boolean
}

export const MessageInfo: React.FC<MessageInfoProps> = ({ message, duration, trigger, type, onTimeout, noCenter }) => {
  const [isVisible, setIsVisible] = useState(false)
  // console.log("message:" + message +"; trigger:" + trigger )
  const classBase = 'p-3 rounded-xl shadow-md transition-all duration-500 ease-in-out transform'
  let classAdd

  switch (type) {
    case 0:
      classAdd = `bg-blue-200 text-blue-800`
      break
    case 1:
      classAdd = `bg-yellow-200 text-yellow-800`
      break
    case 2:
      classAdd = 'bg-red-200 text-red-800'
      break
  }
  
  // Animation classes
  const animationClass = isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
  const className = `${classBase} ${classAdd} ${animationClass}`

  useEffect(() => {
    if (message) {
      // Small delay to allow render before transition
      requestAnimationFrame(() => {
        setIsVisible(true)
      })
      
      const timer = setTimeout(() => {
        setIsVisible(false) 
        
        if (onTimeout) {
          // Delay callback to allow fade out
          setTimeout(onTimeout, 500)
        }
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [trigger, message])

  if (!message) return null

  const bottom_center = `${noCenter ? '' : 'fixed bottom-4 left-1/2 -translate-x-1/2 z-50'} `
  // const center_center = "fixed inset-0 flex items-center justify-center";

  return <MsgInfo externalClass={bottom_center} internalClass={className} message={message} />
}
const MsgInfo: React.FC<{ externalClass: string; internalClass: string; message: string }> = ({
  externalClass,
  internalClass,
  message,
}) => {
  return (
    <div className={externalClass}>
      <div className={internalClass}>{message}</div>
    </div>
  )
}
export const Info: React.FC<InfoProps> = ({ message, trigger, onTimeout, noCenter }) => {
  return (
    <MessageInfo
      message={message}
      duration={2000}
      trigger={trigger}
      type={0}
      onTimeout={onTimeout}
      noCenter={noCenter}
    />
  )
}
export const Warning: React.FC<InfoProps> = ({ message, trigger, onTimeout }) => {
  return <MessageInfo message={message} duration={3000} trigger={trigger} type={1} onTimeout={onTimeout} />
}

export const Alert: React.FC<InfoProps> = ({ message, trigger, onTimeout }) => {
  return <MessageInfo message={message} duration={3000} trigger={trigger} type={2} onTimeout={onTimeout} />
}
